import { HomeOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Input, Layout, Menu, Modal, Space, Typography, message } from 'antd';
import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const { Header, Content, Footer } = Layout;
const ADMIN_PASSWORD = 'bosen';

const menuItems = [
  { key: '/', icon: <HomeOutlined />, label: '首页' },
];

export default function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [pwdOpen, setPwdOpen] = useState(false);
  const [pwd, setPwd] = useState('');

  const goAdmin = () => {
    // 每次进入都必须输入密码
    setPwd('');
    setPwdOpen(true);
  };

  const handleOk = () => {
    if (pwd === ADMIN_PASSWORD) {
      setPwdOpen(false);
      setPwd('');
      navigate('/admin');
    } else {
      message.error('密码错误');
      setPwd('');
    }
  };

  return (
    <Layout className="app-layout">
      <Header className="app-header" style={{ display: 'flex', alignItems: 'center', padding: '0 24px' }}>
        <Typography.Title level={4} style={{ color: '#fff', margin: 0, whiteSpace: 'nowrap' }}>
          数字化健康度体检平台
        </Typography.Title>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          style={{ flex: 1, minWidth: 0, marginLeft: 24 }}
        />
        <Button
          type="text"
          icon={<SettingOutlined />}
          onClick={goAdmin}
          style={{ color: '#fff' }}
        >
          管理后台
        </Button>
      </Header>
      <Content className="app-content">
        <Outlet />
      </Content>
      <Footer className="app-footer">
        企业数字化健康度体检平台 ©2026 · 本报告基于企业自评，仅供参考
      </Footer>
      <Modal
        title="管理后台访问"
        open={pwdOpen}
        onOk={handleOk}
        onCancel={() => setPwdOpen(false)}
        okText="进入"
        cancelText="取消"
        destroyOnClose
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Typography.Text>请输入管理密码</Typography.Text>
          <Input.Password
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            onPressEnter={handleOk}
            placeholder="管理密码"
            autoFocus
          />
        </Space>
      </Modal>
    </Layout>
  );
}
